var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bg-white h-full"},[_c('div',{staticClass:"pt-3"},[_c('TemplateManagement')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }